import { __decorate, __metadata } from "tslib";
import { injectable } from 'inversify';
import { create, dialog } from '@patsnap/tahiti-core';
let GroupOrUserInputServiceReaderImpl = class GroupOrUserInputServiceReaderImpl {
    read() {
        const deferred = create();
        this._copyCustomFieldDialog.onSubmit(async (result, next) => {
            deferred.resolve([result, next]);
        });
        this._copyCustomFieldDialog.open();
        return deferred.promise;
    }
};
__decorate([
    dialog(() => import('./components/CopyCustomFieldDialog.vue')),
    __metadata("design:type", Object)
], GroupOrUserInputServiceReaderImpl.prototype, "_copyCustomFieldDialog", void 0);
GroupOrUserInputServiceReaderImpl = __decorate([
    injectable()
], GroupOrUserInputServiceReaderImpl);
export { GroupOrUserInputServiceReaderImpl };
